
export const CONTACT_US = {
    GET_CONTACT : 'contact-us/list',
}

export const GENERAL_TESTIMONIAL = {
    GET_GENERAL_TESTIMONIALS : 'testimonials/testimonials-list',
    ADD_GENERAL_TESTIMONIALS : 'testimonials/add-testimonial',
    EDIT_GENERAL_TESTIMONIALS : 'testimonials/update-testimonial'
}
export const TEAM_MEMBERS = {
    GET_TEAMS : 'team-members/list',
    ADD_TEAM : 'team-members/add-team-member',
    EDIT_TEAM : 'team-members/update-team-member',
    UPDATE_TEAM_DETAILS : 'team-members/update-team-member-section'
}

export const PARTNERS = {
    GET_PARTNER : 'partners/list',
    ADD_PARTNER : 'partners/add-partner',
    EDIT_PARTNER : 'partners/update-partner',
    FETCH_PARTNER: 'partner/fetch-partner',
    UPDATE_PARTNER_DETAILS: 'partners/update-page-details'
}

export const ADVANTAGE = {
    GET_ADVANTAGE_LIST : 'pages/advantages-list',
    ADD_ADVANTAGE: 'pages/add-advantage',
    EDIT_ADVANTAGE : 'pages/update-advantage',
    UPDATE_ADVANTAGE_FETCH_DETAILS: 'pages/update-advantage-page-details'
}

export const RECRUITMENT = {
    EDIT_RECRUITMENT : 'pages/update-whyus-page-details',
    GET_RECRUITMWNT : 'pages/get-whyus-page-details',
}

export const CONTACT = {
    GET_CONTACT : 'pages/get-contactus-page-details',
    EDIT_CONTACT : 'pages/update-contactus-page-details',
    UPDATE_CONTACT_DETAILS: 'pages/update-contactus-section-details',
    GET_CONTACT_DETAILS: 'pages/get-contactus-section-details'
}

export const ABOUT_US = {
    GET_ABOUT_US_INFO_LIST : 'pages/get-about-us-about-section',
    ADD_ABOUT_US_INFO : 'pages/add-aboutus-step',
    EDIT_ABOUT_US_INFO : 'pages/update-aboutus-step',
    FETCH_ABOUT_US_MAIN: 'aboutus/aboutus-fetch',
    UPDATE_ABOUT_US_MAIN : 'pages/update-about-us-section',
    ADD_ABOUT_US_MISSION_VISION : 'pages/add-aboutus-vision-mission',
    EDIT_ABOUT_US_MISSION_VISION : 'pages/update-aboutus-vision-mission',
    GET_ABOUT_US_MAIN_PRIORITY_LIST : 'pages/get-aboutus-service-section',
    ADD_ABOUT_US_PRIORITY : 'pages/add-aboutus-service',
    EDIT_ABOUT_US_PRIORITY : 'pages/update-aboutus-service',
    UPDATE_ABOUT_US_MAIN_TITLE : 'pages/update-aboutus-main-title',
    UPDATE_ABOUT_US_PRIORITY_MAIN_TITLE : 'pages/update-aboutus-service-section',
    FETCH_VALUABLE_TEAM: 'pages/get-aboutus-team-section-details',
    UPDATE_VALUABLE_TEAM : 'pages/update-aboutus-team-section-details',
    GET_ABOUT_US_RECRUITMENT_LIST : 'pages/get-aboutus-recruitment-section-details',
    UPDATE_ABOUT_US_RECRUITMENT_TEAM : 'pages/update-aboutus-recruitment-list',
    GET_ABOUT_US_MAIN_PROCESS_LIST : 'pages/get-aboutus-process-section',
    UPDATE_ABOUT_US_PROCESS_MAIN_TITLE : 'pages/update-aboutus-process-section',
    ADD_ABOUT_US_PROCESS : 'pages/add-aboutus-process',
    EDIT_ABOUT_US_PROCESS : 'pages/update-aboutus-process',
    UPDATE_ABOUT_US_RECRUITMENT_TITLE : 'pages/update-aboutus-recruitment-section-details',
    ADD_ABOUT_US_RECRUITMENT : 'pages/add-aboutus-recruitment',
    EDIT_ABOUT_US_RECRUITMENT : 'pages/update-aboutus-recruitment',
    FETCH_ABOUT_US_PARTNER: 'pages/get-aboutus-partner-section-details',
    UPDATE_ABOUT_US_PARTNER : 'pages/update-aboutus-partner-section-details',

    // for recruitment process

    UPDATE_RECRUITMENT_PROCESS: 'pages/update-recruiting-process-section-details',
    GET_RECRUITMENT_PROCESS: 'pages/get-recruiting-process-section-details',
    ADD_RECRUITMENT_PROCESS : 'pages/add-recruiting-step',
    EDIT_RECRUITMENT_PROCESS : 'pages/update-recruiting-step/',



}

export const BLOG = {
     // for blog section
     GET_BLOG_DETAILS : 'pages/get-blogs-section-details',
     UPDATE_BLOG_DETAILS: 'pages/update-blogs-section-details',
     GET_BLOG_LIST : 'pages/get-blogs',
     ADD_BLOG : 'pages/add-blog',
     EDIT_BLOG : 'pages/update-blog',
}

export const CATEGORY = {
    GET_CATEGORY_LIST : 'pages/get-blog-categories',
    ADD_CATEGORY : 'pages/add-blog-category',
    EDIT_CATEGORY : 'pages/update-blog-category',
}

export const HOMEPAGE = {
    FETCH_HOME_PAGE: 'pages/get-home-page-section-details',
    UPDATE_HOME_PAGE: 'pages/update-home-page-section-details',
    SUBSCRIPTION_LIST: 'pages/newsletter-subscriptions-list',
    PRIVACY_POLICY: 'pages/privacy-policy',
    UPDATE_PRIVACY_POLICY: 'pages/update-privacy-policy'
}

export const SOCIAL_MEDIA = {
    GET_SOCIAL : 'pages/get-social-links',
    UPDATE_SOCIAL : 'pages/update-social-links',
}

export const SERVICE_LIST = {
    GET_SERVICE_LIST : 'pages/get-services',
    ADD_SERVICE : 'pages/add-service',
    EDIT_SERVICE : 'pages/update-service',
    GET_SERVICE_RECRUITMENT_LIST : 'pages/get-service-recruits',
    ADD_SERVICE_RECRUITMENT : 'pages/add-service-recruit',
    EDIT_SERVICE_RECRUITMENT : 'pages/update-service-recruit',
    GET_PROCESS_LIST : 'pages/get-service-process',
    ADD_SERVICE_PROCESS : 'pages/add-service-process',
    EDIT_SERVICE_PROCESS : 'pages/update-service-process',
    UPDATE_SERVICE_PROCESS_DETAILS: 'pages/update-service-process-details'
}

export const PRICE = {
    GET_PRICE_LIST : 'pages/get-service-prices',
    ADD_PRICE : 'pages/add-service-price',
    EDIT_PRICE : 'pages/update-service-price',
}

export const AUTHENTICATION = {
    LOGIN_USER: 'candidate-portal/auth/password-verify',
    FORGOT_PASSWORD: 'User/Forgot',
    RESET_PASSWORD: 'User/Reset',
    PASSWORD_REQUEST: 'candidate-portal/auth/password-request'
}

export const FACILITY = {
    FETCH_FACILITY_LIST: 'Facilities/List',
    FETCH_JOB_TYPE_LIST: 'Facilities/JobDetails',
    UPDATE_CANDIDATE_STATUS: 'Facilities/CandidateStatusChange',
    FETCH_DURATION_LIST: 'Facilities/DurationList',
    UPDATE_ROAD_TEST_PROCESS: 'Facilities/RoadTest',
    UPDATE_QUAL_CART_PROCESS: 'Facilities/CandidateTest',
    FETCH_FULL_CANDIDATE_DETAILS_USING_CLINETID: 'Facilities/CandidateDetails',
    UPDATE_DRIVER_DETAILS: 'Facilities/DriverDetails',
    UPDATE_FEEDBACK: 'Facilities/Feedback',
    FETCH_STATUS_LIST: 'Facilities/StatusList',
    UPDATE_CONVERSATION: 'Facilities/CandidateConversationSubmit',
    CANDIDATE_JOB_LIST_CAN_BAN: 'User/CanbanSettingsUpdate',
    ADD_NEW_CANDIDATE: 'Facilities/CandidateAdd',
    FETCH_POSITION_LIST: 'Facilities/JobTypList',


}

export const USER = {
    UPDATE_USER_PROFILE: 'User/Profile',
    USER_LIST: '/User/UserList',
    ADD_USER_PROFILE_FROM_LIST: 'User/UserAdd',
    EDIT_USER_PROFILE_FROM_LIST: 'User/UserUpdate',
    NOTIFICATION_LIST: '/User/UserNotificationList',
    USER_REGISTER: '/User/Register',
    USER_SETTINGS_NOTIFICATION_SUBMIT: 'User/RegisterIntervalUpdate',
    USER_CLIENT_LIST: '/User/ClientList',
    LOGIN_WITH_CLIENT: 'User/ClientSelectForAdmin',
    ACCOUNT_EXECUTIVE_LIST: '/User/AccountExecutive',
    FETCH_JOB_DETAILS: '/ClientAPI/ClientDetailsByLink',
    APPLY_JOB_LIST: '/ClientAPI/JobTypListByLink',
    APPLY_NOW: '/ClientAPI/AddCandidate',
    CANDIDATE_DETAILS: 'candidate-portal/details',
    ACCEPT_ROAD_TEST_ACCEPTED: 'candidate-portal/road-test',
    ACCEPT_ROAD_TEST_REJECTED: 'candidate-portal/road-test',
    CANDIDATE_CONVERSATION_SUBMIT: 'candidate-portal/conversation',
    CANDIDATE_INTERESTED: 'candidate-portal/interested',
    CANDIDATE_NOT_INTERESTED: 'candidate-portal/not-interested',
    CANDIDATE_CALLBACK: 'candidate-portal/callback',
    CANDIDATE_CANCELLED_CALLBACK: 'candidate-portal/callback/cancel',
    CANDIDATE_UPDATE_ALL_DATA: 'candidate-portal/profile',
    CANDIDATE_UPDATE_PROFILE_DATA: 'candidate-portal/profile',
    CANDIDATE_UPDATE_DOCUMENTS_DATA: 'candidate-portal/driver-details',
    CANDIDATE_UPDATE_EXPERIENCE_DATA: 'candidate-portal/work-experience',
    CANDIDATE_DELETE_EXPERIENCE_DATA: 'candidate-portal/work-experience/delete',
    CANDIDATE_ONBOARDING_DOCUMENTS_LIST: 'candidate-portal/onboarding/documents',
    CANDIDATE_UPDATE_CITIGEN: 'candidate-portal/onboarding/citizenship',
    CANDIDATE_ONBOARDING_DOCUMENT_UPLOAD: 'candidate-portal/onboarding/documents/upload-batch',


}


